import { definePreset } from '@primeuix/themes';
import lara from '@primeuix/themes/lara';

const tucuatePurple = {
  50: '#eae5fd',
  100: '#d3c8fb',
  200: '#ad93f8',
  300: '#8856f3',
  400: '#641dcd',
  500: '#360c75',
  600: '#2e0966',
  700: '#240653',
  800: '#1d0445',
  900: '#10022c',
  950: '#0b0123',
};

// Invertido (diseño): versión de primary para fondo oscuro. Un solo lugar para cambiarlo.
const tucuatePurpleInverted = '#b799d6';

export const tucuatePreset = definePreset(lara, {
  primitive: {
    borderRadius: {
      none: '0',
      xs: '0.00rem',
      sm: '0.25rem',
      md: '0.50rem',
      lg: '0.75rem',
      xl: '1.00rem',
    },
  },
  semantic: {
    primary: {
      50: tucuatePurple['50'],
      100: tucuatePurple['100'],
      200: tucuatePurple['200'],
      300: tucuatePurple['300'],
      400: tucuatePurple['400'],
      500: tucuatePurple['500'],
      600: tucuatePurple['600'],
      700: tucuatePurple['700'],
      800: tucuatePurple['800'],
      900: tucuatePurple['900'],
      950: tucuatePurple['950'],
      color: `light-dark({primary.500}, ${tucuatePurpleInverted})`,
      hoverColor: `light-dark({primary.600}, color-mix(in srgb, ${tucuatePurpleInverted} 85%, white))`,
      activeColor: `light-dark({primary.700}, color-mix(in srgb, ${tucuatePurpleInverted} 85%, black))`,
    },
    surface: {
      0: '#ffffff',
      50: '#EEF1F6',
      100: '#DDE3ED',
      200: '#B7C5DA',
      300: '#94AAC9',
      400: '#7890AF',
      500: '#61758F',
      600: '#4D5D72',
      700: '#394556',
      800: '#262F3B',
      900: '#161C24',
      950: '#0C1117',
    },
  },
  components: {
    card: {
      body: {
        padding: '0 0 0 0',
      },
    },
    panel: {
      content: {
        padding: '0 0 0 0',
      },
    },
    tabs: {
      tab: {
        borderWidth: '0 0 2px 0',
      },
      tabpanel: {
        padding: '0 0 0 0',
      },
    },
  },
});
